import { Routes, Route } from "react-router-dom";

import { ClientsPage } from "./pages/ClientsPage";
import { OrganizationClientsPage } from "./pages/OrganizationClientsPage";

export const ClientsNavigation = () => {
  return (
    <Routes>
      <Route index element={<ClientsPage />} />
      <Route path="organizations/:organizationId" element={<OrganizationClientsPage />} />
    </Routes>
  );
};
